








import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { RootState } from "@/store";
import * as m from "@/store/modules/AlertModule/mutations";
import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";

export default Vue.extend({
  data() {
    return {
      message: "hello"
    };
  },
  computed: {
    ...mapState({
      alertList: (state: RootState) => state.alert.list
    })
  },
  methods: {
    ...mapMutations([m.ADD_ALERT, m.REMOVE_ALERT_AT]),
    addNewAlert(): void {
      this[m.ADD_ALERT](new AlertModel(AlertModelType.Error, "hello"));
    }
  }
});
